import SuggestInput from "./suggest-input";

export default SuggestInput;